
// import Vue from 'vue'
import { MAX_END_SESSION_TIME } from '@/constants/business'

const validate = (value, { time = MAX_END_SESSION_TIME, prolongation = 0 } = {}) => {
  return true
  // if (Vue.isTestMode()) {
  //   return true
  // }
  // if (!value) return false
  // const endDate = Vue.prototype.$moment(value)
  // // с учетом продления сессии
  // const endDateWithProlongation = prolongation
  //   ? endDate.add(Number(prolongation), TIME_UNITS.MINUTES)
  //   : endDate

  // const topTimeBoundaries = Vue.prototype.$moment(time, 'HH:mm:ss')
  // // время завершения сессии не позднее 16:00
  // return topTimeBoundaries.isSameOrAfter(Vue.prototype.$moment(endDateWithProlongation.format('HH:mm:ss'), 'HH:mm:ss'))
}

export default {
  validate,
  params: ['prolongation']
}
